export const DUAL_TONE_TEXT_SLICE_TYPE = 'solution_dual_tone_text';

export enum VARIANT {
  LIGHT = 'Light',
  DARK = 'Dark',
  SKY = 'Sky',
}
